export enum FilterListEnum {
  'Not Mapped' = 0,
  'Mapped' = 1,
  'All' = 2,
}

export const filterList = Object.entries(FilterListEnum)
  .filter(([key]) => isNaN(Number(key)))
  .map(([name, value]) => ({
    name,
    value: value as number,
  }));

export type FilterListItem = {
  name: string;
  value: number;
  isDisabled: boolean;
};
